/* eslint-disable object-curly-newline */
import _ from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { MoreVertical20Regular } from '@fluentui/react-icons';
import {
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from '@fluentui/react-components';
import { AdsStudioFoldersGridCell } from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useFolderGridCellWithContextMenuStyle } from '../styles/folders-grid-cell-with-context-menu-style';

function getMenuItems({
  item,
  isReadonly,
  onSelectMenuItemClick,
  onOpenMenuItemClick,
  onDeleteMenuItemClick,
  onRenameMenuItemClick,
  onViewPerformanceClick,
  i18n,
}) {
  const items = _.compact([{
    key: 'deleteItem',
    text: i18n.getString(_TL_('Delete')),
    ariaLabel: i18n.getString(_TL_('Delete')),
    onClick: onDeleteMenuItemClick ? () => onDeleteMenuItemClick(item) : _.noop,
    disabled: !!isReadonly,
  },
  {
    key: 'openCell',
    text: i18n.getString(_TL_('Open')),
    ariaLabel: i18n.getString(_TL_('Open')),
    onClick: onOpenMenuItemClick ? () => onOpenMenuItemClick(item) : _.noop,
  },
  {
    key: 'renameItem',
    text: i18n.getString(_TL_('Rename')),
    ariaLabel: i18n.getString(_TL_('Rename')),
    onClick: onRenameMenuItemClick ? () => onRenameMenuItemClick(item) : _.noop,
    disabled: !!isReadonly,
  },
  {
    key: 'selectCell',
    text: i18n.getString(_TL_('Select')),
    ariaLabel: i18n.getString(_TL_('Select')),
    onClick: onSelectMenuItemClick ? () => onSelectMenuItemClick(item) : _.noop,
  },
  {
    key: 'viewPerformance',
    text: i18n.getString(_TL_('View performance')),
    ariaLabel: i18n.getString(_TL_('View performance')),
    onClick: onViewPerformanceClick ? () => onViewPerformanceClick(item) : _.noop,
  },
  ]);
  return items;
}

const FoldersGridCellWithContextMenu = ({
  item,
  isReadonly,
  onSelectMenuItemClick,
  onOpenMenuItemClick,
  onDeleteMenuItemClick,
  onRenameMenuItemClick,
  onViewPerformanceClick,
  i18n,
  ...rest
}) => {
  const classes = useFolderGridCellWithContextMenuStyle();
  const menuItems = useMemo(() => getMenuItems({
    item,
    isReadonly,
    onSelectMenuItemClick,
    onOpenMenuItemClick,
    onDeleteMenuItemClick,
    onRenameMenuItemClick,
    onViewPerformanceClick,
    i18n,
  }), [item, isReadonly, onSelectMenuItemClick, onOpenMenuItemClick, onDeleteMenuItemClick, onRenameMenuItemClick, onViewPerformanceClick, i18n]);

  const renderAccessory = useCallback(() => (
    <Menu positioning="below-end">
      <MenuTrigger>
        <div className={classes.folderCellContextMenuButton}>
          <MoreVertical20Regular
            aria-label="more actions"
          />
        </div>
      </MenuTrigger>
      <MenuPopover>
        <MenuList className="folder-accessory-menu-box">
          {menuItems.map(menuItem => (
            <MenuItem
              key={menuItem.key}
              onClick={menuItem.onClick}
              disabled={menuItem.disabled}
            >
              {menuItem.text}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>), [classes.folderCellContextMenuButton, menuItems]);

  return (<AdsStudioFoldersGridCell
    item={item}
    i18n={i18n}
    renderAccessory={renderAccessory}
    {...rest}
  />);
};

FoldersGridCellWithContextMenu.propTypes = {
  item: PropTypes.shape({}).isRequired,
  isReadonly: PropTypes.bool,
  // show dropdown menu
  onSelectMenuItemClick: PropTypes.func,
  onOpenMenuItemClick: PropTypes.func,
  onDeleteMenuItemClick: PropTypes.func,
  onRenameMenuItemClick: PropTypes.func,
  onViewPerformanceClick: PropTypes.func,

  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

FoldersGridCellWithContextMenu.defaultProps = {
  isReadonly: false,
  onSelectMenuItemClick: undefined,
  onOpenMenuItemClick: undefined,
  onDeleteMenuItemClick: undefined,
  onRenameMenuItemClick: undefined,
  onViewPerformanceClick: undefined,
};

export const AdsStudioFoldersGridCellWithContextMenu = FoldersGridCellWithContextMenu;
